import {Routes} from "@angular/router";
import {ConsoleGuard, HasStationGuard} from "@shared/route-guards";
import {consoleRoutes} from "./console";
import {stationRoutes} from "./station";
import {settingsRoutes} from "./settings";

enum Paths {
    SETTINGS = "settings",
    CONSOLE = "console",
    STATION = "station",

}

const UserSettingsComponent = () => import("@pages/user-settings/ui/user-settings-page/user-settings.component").then(m => m.UserSettingsComponent);
const ConsolePageComponent = () => import("@pages/console/ui/console-page/console-page.component").then(m => m.ConsolePageComponent);

export const mainRoutes: Routes = [
    {
        path: Paths.SETTINGS,
        loadComponent: UserSettingsComponent,
        children: settingsRoutes
    },

    {
        path: Paths.CONSOLE,
        canActivate: [ConsoleGuard],
        loadComponent: ConsolePageComponent,
        children: consoleRoutes
    },
    {
        path: Paths.STATION,
        canActivate: [HasStationGuard],
        children: stationRoutes
    }
];
